module.exports = __webpack_public_path__ + "static/media/DJLuvaLuva-Thumb.055bca2b.jpg";